/* eslint-disable */
// vue
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App/'
import router from './router'
import store from './store/'

// plugins
import VueSVGIcon from 'vue-svgicon'
import VueI18n from 'vue-i18n'
import Notifications from 'vue-notification'
import Vuelidate from 'vuelidate'
import VCalendar from 'v-calendar'

// swiper slider
import {
  Swiper as SwiperClass,
  Pagination,
  Navigation,
  Autoplay
} from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import 'swiper/swiper-bundle.min.css'
SwiperClass.use([Pagination, Navigation, Autoplay])
Vue.use(getAwesomeSwiper(SwiperClass))

// i18n config
import i18n from './i18n/'

// all js icons import used for VueSVGIcon plugin
import './assets/icons'

// types
import { USER_MODULE_NAME } from '@/modules/User/store/types'

// vuex
import { mapState } from 'vuex'

// sentry
import * as Sentry from '@sentry/vue' //Remove Sentry for PRE
import { Integrations } from '@sentry/tracing'

// vue router store sync
sync(store, router)

Vue.config.productionTip = false

// plugins - use
Vue.use(VueSVGIcon)
Vue.use(VueI18n)
Vue.use(Notifications)
Vue.use(Vuelidate)
Vue.use(VCalendar)

var host = window.location.host
var subdomain = host.split('.')[1]
var maDomain = true
if (subdomain === 'allianz') {
  maDomain = false
}
Vue.prototype.$maDomain = maDomain
/**
 * @module
 * @name main
 * @description Main script is executed once, before App.js, at the
 *              application start.
 *              *Routes, role, token, admin permissions* management between
 *              localStorage and app.
 */

/**
 * @function
 * @name Vue.mixin
 * @description Global mixin: stateUserIsCompanyAdmin,
 *              stateUserIsSuperAdmin are passed into all components. There all
 *              also another function called throwNotification used as a
 *              notification function wrapper.
 */
Vue.mixin({
  /**
   * @property {Boolean} stateUserIsCompanyAdmin If user is company admin.
   * @property {Boolean} stateUserIsSuperAdmin If user is super admin.
   */
  computed: {
    ...mapState(USER_MODULE_NAME, {
      stateUserIsCompanyAdmin: 'isCompanyAdmin' || false,
      stateUserIsSuperAdmin: 'isSuperAdmin' || false
    })
  },
  methods: {
    /**
     * @function
     * @name throwNotification
     * @description Wrapper for OK / KO notifications. Params containing
     *              notification text, should be already translated.
     * @param {String} title Title of notification.
     * @param {String} text Text of notification.
     * @param {String} type 'OK' throw green / check notification.
     *                      'KO' throw red / x notification.
     */
    throwNotification: function (title, text, type = 'OK') {
      const icon = type.toLowerCase()
      this.$notify({
        group: 'main',
        data: { title, text, icon },
        duration: 6000
      })
    }
  }
})

/**
 * @function
 * @name floatTofixed
 * @decription Filter - Takes value an fixed it to decimals.
 * @param {Float|Number} value Value to fix.
 * @param {Number} decimals Number of decimals to fix.
 * @return {Float|Number} Value fixed to number of decimals.
 */
Vue.filter('floatToFixed', function (value, decimals) {
  if (Math.round(value) !== value) {
    return value.toFixed(decimals)
  }
  return value
})

/**
 * @function
 * @name textOverflow
 * @description Filter - Shorten a string.
 * @param {String} value String to be shortened.
 * @param {Number} length Maximum length of returned string.
 * @return {String} String shortened or full string if its length is less than
 *                  length param.
 */
Vue.filter('textOverflow', function (value, length) {
  return value.length > length ? `${value.substr(0, length)}...` : value
})

Vue.config.errorHandler = function (err, vm, info) {
  if (process.env.NODE_ENV === 'development') {
    console.debug('err', err, vm, info)
  }
}

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')

///------ URL ENTORNOR DEV
const DEV = 'devselfcare-mavalue.plataforma-smart.com'

///------ URL ENTORNOR PRE
const PRE = 'preselfcare-mavalue.plataforma-smart.com'
const PRE2 = 'mesdommageshabitations-rf.allianz.fr'

///------ URL ENTORNOR PRO
const PRO = 'selfcare-mavalue.plataforma-smart.com'
const PRO2 = 'mesdommageshabitations.allianz.fr'

// Remove Sentry on PRE∫
Sentry.init({
  Vue,
  dsn: 'https://1ad9ba48a775428abdca0c590cc533a1@o912381.ingest.sentry.io/5905038',
  environment: 'pro-production',
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: [PRO, PRO2, /^\//],
      trackComponents: true,
      trackComponents: ['InputFile', 'FileImg', 'otp']
    })
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  allowUrls: [PRO, PRO2, /^\//]
})

/*
 * ONLY available during E2E tests can let us accesing to the state
 * within a test
 */
if (window.Cypress) {
  window.app = app
}
